<template>
    <div class="m-rebate">
        <h5 class="title"></h5>

        <div class="view">

            <div class="info">
                <div class="text">                    
                    <p>往届鸡王系列换装拥有其一，再获得辛宪英*疯狂吉娃</p>
                    <p>即可获得<b>【大吉大利鸡王宝藏】</b></p>
                </div>
            </div>

            <div class="skin-view">
                <div class="list-1">
                    <ul class="skin-list">
                        <li v-for="(item,index) in skin_config['list']" :key="index">
                            <!-- <game-item :id="item.id" :locked="true"></game-item> -->
                            <div class="skin-img" :class="[ 's-' + (index+1) , {'act' : skin_status[item.id.toLowerCase() + '_flag'] == 1}]"  @click="$item_tips(item.id)"></div>
                            <div class="skin-name">{{ item.name }}</div>
                            <div class="status" :class="{'act' : skin_status[item.id.toLowerCase() + '_flag'] == 1}"></div>
                        </li>
                    </ul>
                </div>
                <div class="list-2">
                    <div class="skin-item" @click="$item_tips(skin_config['now'].id)">
                        <!-- <game-item :id="skin_config['now'].id" :locked="true"></game-item> -->
                        <div class="skin-img" :class="[ 's-sp' , {'act' : skin_status[skin_config['now'].id.toLowerCase() + '_flag'] == 1}]"  @click="$item_tips(skin_config['now'].id)"></div>
                        <div class="status" :class="{'act' : skin_status[skin_config['now'].id.toLowerCase() + '_flag'] == 1}"></div>                        
                    </div>
                </div>

                <div class="reward-view">
                    <h6 class="reward-name"></h6>

                    <div class="reward-list">
                        <ul>
                            <li v-for="(item,index) in pack_config" :key="index">
                                <div class="reward-item" @click="$item_tips(item.id)"><game-item :id="item.id" :num="item.num" :locked="true"></game-item></div>                           
                                <!-- <div class="item-name">{{ item.name }}</div>                        -->
                            </li>
                        </ul>
                    </div>

                    <div class="u-btn apply" :class="{'disabled' : (!skin_status['skin_flag'] && $store.state.userinfo.areaId) || ($store.state.account.uflag & 4) == 4}" @click="apply_pack(4)"></div>
                </div>

            </div>


        </div>
    </div>
</template>

<style scoped>
h5.title{
    width: 508px;
    height: 132px;
    margin: 0 auto 0;
    background-image: url(~@/assets/images/title-shop-1.png);
}

.view{
    /* margin-top: -950px; */
}

.skin-view{
    width: 750px;
    height: 1373px;
    /* margin-bottom: 18px; */
    padding-top: 28px;
    background-image: url(~@/assets/images/bg-back-shop.png);
}

.skin-view .list-1{
    /* width: 513px;
    height: 155px;
    background-image: url(~@/assets/images/bg-skin-list-1.png); */
}

.skin-view .list-2{
    /* width: 183px;
    height: 155px;
    background-image: url(~@/assets/images/bg-skin-list-2.png); */
}

.skin-list{
    display: flex;
    align-items: center;
}

.list-1 .skin-list{
    /* padding-left: 71px;
    padding-right: 31px; */
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0 70px;
}

.list-1 .skin-list li{
    position: relative;
    width: 184px;
    height: 296px;
    padding-top: 84px;
    background-image: url(~@/assets/images/item-card.png);
}

.skin-name{
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    color: #853a20;
}

.list-1 .skin-list .skin-img{
    width: 141px;
    height: 141px;
    margin:  0 auto 30px;
}

.skin-img.s-1{
    background-image: url(~@/assets/images/skin/1.png); 
}

.skin-img.s-2{
    background-image: url(~@/assets/images/skin/2.png); 
}


.skin-img.s-3{
    background-image: url(~@/assets/images/skin/3.png); 
}


.skin-img.s-4{
    background-image: url(~@/assets/images/skin/4.png); 
}

.skin-img.s-5{
    background-image: url(~@/assets/images/skin/5.png); 
}

.skin-img.s-6{
    background-image: url(~@/assets/images/skin/6.png); 
}

.list-2{
    display: flex;
    align-items: center;    
    justify-content: center;
    margin-top: 12px;
    margin-bottom: 12px;
}

.skin-item{
    position: relative;
}

.skin-img.s-sp{
    width: 695px;
    height: 287px;
    background-image: url(~@/assets/images/skin/sp.png); 
}

.skin-item .pic{
    margin: 0 auto;
}

.list-1 .status{
    position: absolute;
    right: -12px;
    top: 42px;
    width: 36px;
    height: 36px;
    margin: 10px auto 0;
    background-image: url(~@/assets/images/skin-circel.png);
    z-index: 5;
}

.list-1 .status.act::after{
    content: '';
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    width: 27px;
    height: 23px;
    transform: translate(-50%,-50%);
    background-image: url(~@/assets/images/skin-act.png);  
}

.list-2 .status{
    position: absolute;
    right: 12px;
    top: -8px;
    width: 42px;
    height: 108px;
    margin: 10px auto 0;
    background-image: url(~@/assets/images/status-disabled.png);
    z-index: 5;
}

.list-2 .status.act{
    background-image: url(~@/assets/images/status-active.png);
}

.info{
    padding: 0 19px;
    color: #f5cf9a;
    text-align: center;
}

.info b{
    color: #fff0a0;
}

.info-title{
    width: 150px;
    height: 27px;
    margin: 0 0 10px;
    background-image: url(~@/assets/images/title-evt-info.png);    
}

.reward-view{
    position: relative;
    width: 657px;
    height: 412px;
    padding: 39px 80px 0;
    box-sizing: border-box;
    margin: 0 auto;
    background-image: url(~@/assets/images/view-pack-1.png);  
}

/* .reward-view::after{
    content: '';
    display: block;
    position: absolute;
    right: -350px;
    top: -175px;
    width: 418px;
    height: 603px;
    background-image: url(~@/assets/images/layer-char-1.png);  
    transform: scale(.9);
} */

.reward-name{
    width: 315px;
    height: 42px;
    margin: 0 auto 50px;
    background-image: url(~@/assets/images/title-pack-1.png);  
}

.reward-list ul{
    display: flex;
    justify-content: space-between;
}

.reward-list li .reward-item{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 118px;
    height: 118px;
    margin: 0 auto;
    background-image: url(~@/assets/images/bg-item.png);    
}

.reward-item .pic{
    width: 92px;
    height: 92px;
}


.item-name{
    width: 120px;
    margin-top: 5px;
    text-align: center;
}

.u-btn.apply{
    position: absolute;
    width: 262px;
    height: 79px;
    left: 50%;
    bottom: 46px;
    transform: translateX(-50%);
    background-image: url(~@/assets/images/btn-apply.png);
}

.u-btn.apply.disabled{
    background-image: url(~@/assets/images/btn-apply-disabled.png);
}
</style>

<script>
export default {
    data (){
        return {
            skin_config : {
                list : [{id : 'FL70',name : '太史慈*请叫我鸡王'},{id : 'FN22',name : '邓艾*天命之子'},{id : 'FN38',name : '布小蛮*布鸡道'},{id : 'FP40',name : '梦*蔡文姬*闻鸡破晓'},{id : 'FP94',name : '孙策*天命狐王'},{id : 'FQ66',name : '梦*刘备*天命大帝'},],
                now : {id : 'FS24',name : ''},
            },
            pack_config : [{id : 'D774',name : '珍宝自选珍材宝箱(7天)',num : 2},{id : 'AG00',name : '高级士兵卡',num : 1},{id : 'Y552',name : '神鸡妙算',num : 1},],
            skin_status : () => {},
        }
    },
    mounted (){
        if(this.$store.state.userinfo.uid)this.query_skin();
        //console.log(this.$store.state.account.uflag & 64)
    },
    methods : {
        apply_pack(gid){

            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            if(!this.skin_status.skin_flag)return this.$toast('领取条件未达成，请检查封灵玉是否已激活');

            if((this.$store.state.account.uflag & gid) == gid)return this.$toast('无法再领取');

            this.$axios.post(ajax_url_map.apply,{
                code : gid,
            })
            .then(
                res => {
                    this.$success_Apply();
                    this.$store.commit("$_setFlag", gid); 
                    //TODO
                    //task_update
                },
                rej => {
                    this.$toast(rej.message);
                }
            )            
        },
        query_skin (){
            //if(!this.$store.state.login)return;
            this.$axios.get(ajax_url_map.skin)
            .then(
                res => {
                    this.skin_status = res.data;
                }
            )
        },
    },    
}
</script>


// WEBPACK FOOTER //
// src/components/Shop/rebate.vue